export const CONNECTED = 0;
export const CONNECTING = 1;
export const DEVICE_RESPONSE = 2;
export const DISCONNECT = 3;
export const ERROR = 5;
export const RESET = 6;
export const FIRMWARE_UPDATE_PACKAGE_LOAD = 10;
export const FIRMWARE_UPDATE_START = 12;
export const SBL_IDENTIFICATION = 13;
export const CYCLE_REQUESTS = 17;
export const DEVICE_USAGE_DATA_CAPABILITIES = 21;
export const STATUS_CHARACTERISTICS = 30;
export const SOFTWARE_IDENTIFICATION = 101;
export const CANCELLATION = 102;
